import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { pluralize } from "utils/pluralize";

type ReactivateConfirmModalProps = {
  open: boolean;
  riskyEmails: string[];
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ReactivateConfirmModal = ({
  open,
  riskyEmails,
  isLoading,
  onCancel,
  onConfirm,
}: ReactivateConfirmModalProps) => {
  const wasOrWere = pluralize(riskyEmails.length, "was", "were", false);

  return (
    <Modal.Root open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <Modal.Content size="small">
        <Modal.Header>
          <Modal.Title>Reactivate these email addresses?</Modal.Title>
          <Modal.Close />
        </Modal.Header>
        <Modal.Body>
          <p className="t-m-0 t-text-body t-text-text-60">
            {riskyEmails.join(", ")} {wasOrWere} suppressed due to a spam
            complaint or manual suppression. Make sure you&apos;ve confirmed
            with the customer before emailing them again.
          </p>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Button onClick={onCancel} disabled={isLoading}>
            Back
          </Button>
          <Button
            customType="primary"
            isLoading={isLoading}
            disabled={isLoading}
            onClick={onConfirm}
          >
            Yes, reactivate
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
